var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6262_87290)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34162 9.56858C5.25651 9.66159 5.13501 9.71973 4.99989 9.71973C4.88013 9.71973 4.76038 9.67322 4.66869 9.57975L2.32972 7.1954C2.1468 7.00893 2.1468 6.70709 2.32972 6.52061C2.51221 6.33459 2.80831 6.33459 2.99123 6.52061L4.53232 8.0916L4.53232 3.51957C4.53232 3.25618 4.74157 3.04242 4.99995 3.04242C5.25832 3.04242 5.46801 3.25618 5.46801 3.51957L5.46801 8.09068L7.0082 6.52061C7.19068 6.33459 7.48722 6.33459 7.66971 6.52061C7.85263 6.70709 7.85263 7.00893 7.66971 7.1954L5.34162 9.56858ZM9.21067 3.99533C8.95229 3.99533 8.74261 3.78158 8.74261 3.51818L8.74261 1.61052C8.74261 1.48396 8.69347 1.36278 8.60574 1.27335C8.518 1.18392 8.39913 1.13382 8.27498 1.13382L1.72523 1.13382C1.60108 1.13382 1.48176 1.1839 1.39447 1.27335C1.30674 1.36278 1.25716 1.48396 1.25716 1.61052L1.25716 3.51818C1.25716 3.78157 1.04791 3.99533 0.789536 3.99533C0.530719 3.99533 0.321472 3.78157 0.321472 3.51818L0.321472 1.61052C0.321472 1.23086 0.469302 0.867304 0.732509 0.598556C0.995717 0.330241 1.35278 0.179544 1.72522 0.179544L8.27497 0.179544C8.6474 0.179544 9.00404 0.330242 9.26724 0.598556C9.53088 0.867316 9.67871 1.23087 9.67871 1.61052L9.67871 3.51818C9.67871 3.78158 9.46905 3.99533 9.21067 3.99533Z",
    fill: "#1890FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6262_87290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(10 10) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.ee0811fbb83ed5e0100cb8d30443786a.svg";
export { ForwardRef as ReactComponent };